import { useCallback, useEffect, useState } from 'react';
import InfoButton from './InfoButton';
import handleInputChange from '../function/HandleInputsChange';
import ValidateValue from '../function/ValidateValue';
import { useNavigation } from '../function/navigation';

function SepableFrame({
  inputName,
  options,
  inputs,
  result,
  setInputs,
  setOptions,
}) {
  const { dispatch } = useNavigation();

  const setSpiralView = useCallback(
    (v) => dispatch({ type: 'spiralView', payload: v }),
    [dispatch]
  );

  const option = options.find((o) => o.field === inputName);

  const [localList, setLocalList] = useState([]);

  const parseValueToList = (value) => {
    if (!value) return [];
    return String(value)
      .split(';')
      .map((s) => s.trim())
      .filter((s) => s !== '' && !Number.isNaN(Number(s)))
      .map((s) => String(Number(s)))
      .sort((a, b) => Number(a) - Number(b));
  };

  const serializeList = (list) => {
    const numbers = list
      .map((s) => s.trim())
      .filter((s) => s !== '' && !Number.isNaN(Number(s)))
      .map((s) => Number(s))
      .sort((a, b) => a - b);
    return numbers.join(';');
  };

  const sortListKeepEmptiesLast = (list) => {
    const numeric = list
      .filter((s) => s !== '' && !Number.isNaN(Number(s)))
      .map((s) => String(Number(s)))
      .sort((a, b) => Number(a) - Number(b));

    const empties = list.filter((s) => s === '');
    return [...numeric, ...empties];
  };

  useEffect(() => {
    setLocalList(parseValueToList(option.value));
  }, [option.value]);

  const pushUpdate = (list) => {
    const serialized = serializeList(list);
    handleInputChange(
      option.field,
      serialized,
      inputs,
      setInputs,
      setOptions,
      setSpiralView
    );
  };

  const handleAdd = () => {
    setLocalList((prev) => [...prev, '']);
  };

  const handleRemove = (idx) => {
    setLocalList((prev) => {
      const updated = prev.filter((_, i) => i !== idx);
      pushUpdate(updated);
      return sortListKeepEmptiesLast(updated);
    });
  };

  const handleChange = (idx, raw) => {
    const nextVal = raw === '' ? '' : String(raw);

    setLocalList((prev) => {
      const updated = [...prev];
      updated[idx] = nextVal;
      const sorted = sortListKeepEmptiesLast(updated);
      pushUpdate(sorted);
      return sorted;
    });
  };

  if (!option) {
    return;
  }

  const inputRender = (
    <div className="separable-inputs">
      {localList.map((entry, idx) => {
        const hasNumber = entry !== '' && !Number.isNaN(Number(entry));
        const checkedValue = hasNumber ? Number(entry) : NaN;

        let validateValue = true;
        let warning = '';

        if (hasNumber) {
          const res = ValidateValue(option, checkedValue, inputs, result);
          validateValue = res.validateValue;
          warning = res.warning;
        }

        return (
          <div className="input" key={`${idx}-${entry}`}>
            <input
              type="number"
              defaultValue={entry}
              onBlur={(e) => handleChange(idx, e.target.value)}
              placeholder="Enter distance"
            />
            <button
              type="button"
              onClick={() => handleRemove(idx)}
              className="remove-button button-warning"
            >
              ×
            </button>

            {!validateValue && warning !== '' && (
              <InfoButton infoText={warning} type="warning" align="right" />
            )}
          </div>
        );
      })}

      <button
        type="button"
        onClick={handleAdd}
        className="button-sm button-primary"
      >
        + Add
      </button>
    </div>
  );

  return (
    <div className="field">
      <div className="name">{option.name}</div>
      {inputRender}
    </div>
  );
}

export default SepableFrame;
